import React, { Component } from "react";
import { QRCodeSVG } from "qrcode.react";
import { ReactComponent as DoorViLogo } from "../assets/black_logo.svg";
import { ReactComponent as BorderBottom } from "../assets/img/border_bottom.svg";
import { ReactComponent as Ring } from "../assets/location.svg";
import { useTranslation } from "react-i18next";
import { getCountryCallingCode } from "libphonenumber-js";

interface QRGenratorProps {
  value: string;
  index: number;
  qr: any;
  qrType: string;
}

function QRGenrator(props: any) {
  const { t } = useTranslation();
  // console.log('t',t);
  console.log(props.countries[0]);

  return (
    <>
      {props.qrType === "home" ? (
        <div className="qr-wrap" style={{height:'426.5px',width:'342px'}}>
          <p className="qr-id" style={{fontSize:'10px',fontWeight:'500'}}>
            {props.countries[0] === "all"
              ? `No ${props.qr.shortId}`
              : `No ${getCountryCallingCode(props.countries[0])}-${
                  props.countries.length
                }-${props.qr.shortId}`}
          </p>
          <p className="qr-val" style={{background:"#fafafa"}}>
            <Ring
              style={{
                width: 22,
                height: 20,
              }}
            />
          </p>

          <QRCodeSVG
            size={300}
            style={{
              margin: "5px 0",
            }}
            className="qrcode"
            value={props.value}
          />
          <div className="qr-footer">
            <p style={{fontSize:"22px"}}>{t("Scan_QR_Code")}</p>
            <p style={{fontSize:"22px"}}>{t("To_Contact_inside")}</p>
            {/* <BorderBottom
              style={{
                marginTop: 3,
                color: "#000",
                background:"#000"                
              }}
            /> */}
            <div style={{border:"1.7px solid rgb(122 122 122)",width:"100%",borderRadius:"40px",margin:"7px 0px"}}></div>
          </div>
          <ul className="qr-notes" >
            <li style={{fontWeight:'600',fontSize:'11px'}}>{t("Please_Do_Not_Knock_or_Ring_The_Bell")}</li>
            <li style={{fontWeight:'600',fontSize:'11px'}}>{t("Scan_Camera")}</li>
          </ul>
          {/* <div className="footer-logo_wrap"> */}
          <DoorViLogo className="footer-logo" style={{height:'100px',width:"200px"}} />
        </div>
      ) : (
        <div className="qr-wrap-vehicle">
          {/* <img src={VehicleBorderPng} className="borderImg" /> */}
          {/* <VehicleBorder className="borderImg" /> */}

          <p className="qr-id" style={{ right: 15, bottom: 5 }}>
            {props.countries[0] === "all"
              ? `No 0-${props.qr.shortId}`
              : `No ${getCountryCallingCode(props.countries[0])}-${
                  props.countries.length
                }${props.qr.shortId}`}
          </p>
          <QRCodeSVG
            size={120}
            style={{
              margin: "5px 0",
            }}
            className="qrcode"
            value={props.value}
          />

          <div className="qr-note-vehicle">
            <p>{t("IN_CASE_OF")}</p>
            <p>{t("WRONGLY_PARKED_EMERGENCY")}</p>
            <BorderBottom
              style={{
                marginTop: 3,
                color: "#fff",
                background:"#000"                
              }}
            />
          </div>
          <div className="qr-footer">
            <p>{t("Scan_QR_Code")}</p>
            <p>{t("To_Contact_Owner")}</p>
          </div>
          <DoorViLogo className="footer-logo" style={{ bottom: 5 }} />
        </div>
      )}
    </>
  );
}

export default QRGenrator;
